import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const TOPO_BASE_PX = 56; // logo abaixo do SubheaderVoltar (sticky top-0 z-40)
const TOPO_INCREMENTO_PX = 14;

// Wrapper genérico de "empilhamento por scroll" (desktop) — position:sticky
// com `top` crescente por índice (cada item gruda um pouco mais baixo que o
// anterior, efeito leque), escala/opacidade decrescendo via useScroll+
// useTransform conforme o item é coberto pelo próximo ao rolar pra baixo.
// Tudo função pura da posição de scroll, então "desempilha" ao rolar pra
// cima sai de graça, sem estado nenhum pra gerenciar.
//
// Usado tanto pela pilha de RESULTADO (ResultadoEnqueteDinamica.js, cards
// read-only) quanto pelo fluxo de VOTAÇÃO no desktop (FormularioDinamico.js,
// cards com input de verdade) — o conteúdo é sempre `children`, este
// componente só cuida do empilhamento, nunca sabe o que tem dentro.
const CardEmpilhavelScroll = ({ indice, children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.92]);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0.5]);

  return (
    <div
      ref={ref}
      className="sticky mb-6"
      style={{ top: `${TOPO_BASE_PX + indice * TOPO_INCREMENTO_PX}px`, zIndex: indice + 1 }}
    >
      <motion.div style={{ scale, opacity }}>{children}</motion.div>
    </div>
  );
};

export default CardEmpilhavelScroll;
